import { render, staticRenderFns } from "./RequestTopup.vue?vue&type=template&id=1aaab773&"
import script from "./RequestTopup.vue?vue&type=script&lang=ts&"
export * from "./RequestTopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports